import type { DeepPartial } from "simplytyped";
import z from "zod";
import { getMessageMediaApiUrlMiddleware } from "../../config/config";
import type { ShellPartner } from "../types";

const partnerZod = z.object({
  accountId: z.string(),
  accountName: z.string(),
  allowLoginUsingSso: z.boolean().nullable(),
  allowRegistration: z.boolean().nullable(),
  description: z.string().nullable(),
  documentationUrl: z.string().nullable(),
  domainName: z.string().nullable(),
  ecosystem: z.string().nullable(),
  email: z.string().nullable(),
  emailToSmsDomain: z.string().nullable(),
  logoUrl: z.string().url(),
  portalLogoUrl: z.string().url(),
  slug: z.string(),
  supportArticleUrls: z.string().nullable(),
});

export type Partner = z.infer<typeof partnerZod>;

export const MMFetchPartnerURL = `${getMessageMediaApiUrlMiddleware()}/partners/v1/partners`;

export const toShellPartner = (data: unknown): ShellPartner => {
  const parsed = partnerZod.safeParse(data);
  if (parsed.success) return parsed.data;
  const errorMessage = "Invalid response from partners";
  console.warn(errorMessage, parsed.error);
  return data as DeepPartial<Partner>;
};
